import { Box, CssBaseline, Hidden } from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";

import { DrawerLayout } from "./DrawerLayout";
import { NavbarLayout } from "./NavbarLayout";

import "../auth/layout/styles.css";
import { ModalRecover } from "../faraday/components/recoverPassword/ModalRecover";
import { NavbarSmallLayout } from "./components/NavbarSmallLayout";
import "./style.css";

const drawerWidth = 240;
const minDrawerWidth = 60;

export const PrincipalLayouts = ({ children }) => {
  const { drawerIsOpen } = useSelector((state) => state.layout);

  return (
    <>
      <Hidden smDown>
        <Box sx={{ flexFlow: 1, zIndex: 9999 }}>
          <CssBaseline />
          <NavbarLayout />
          <DrawerLayout />
          <Main open={drawerIsOpen}>
            <Box sx={{ minHeight: "calc(100vh - 79px)" }} bgcolor="#F5F5F5">
              <Box
                sx={{ minHeight: "calc(100vh - 100px)" }}
                margin={"0px 15px"}
                marginBottom="15px"
                padding={"15px 15px"}
                bgcolor="#FFF"
                borderRadius={2}
              >
                {children}
              </Box>
            </Box>
          </Main>
          <ModalRecover />
        </Box>
      </Hidden>
      <Hidden smUp>
        <Box sx={{ flexFlow: 1 }}>
          {/* <CssBaseline /> */}
          <NavbarSmallLayout />
          <main>
            <Box sx={{ minHeight: "calc(100vh - 71px)" }} bgcolor="#F5F5F5">
              <Box
                sx={{ minHeight: "calc(100vh - 100px)" }}
                margin={"0px 15px"}
                marginBottom="15px"
                padding={"15px 15px"}
                bgcolor="#FFF"
                borderRadius={2}
              >
                {children}
              </Box>
            </Box>
          </main>
          <ModalRecover />
        </Box>
      </Hidden>
    </>
  );
};

const Main = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: `calc(100% - ${minDrawerWidth}px)`,
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: minDrawerWidth,
  zIndex: 0,
  position: "relative",
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
    zIndex: 0,
  }),
}));
